export default __webpack_public_path__ + "static/site-snapshot-0e19463e8130c16bc5c01d9717cf8442.png";